<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>充值异常列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <bill-list @refresh="refreshList"></bill-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import BillList from './components/BillList';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Bill',
  data() {
    return {};
  },
  computed: {
    ...mapState('abnormal', ['coinList', 'pagination'])
  },
  methods: {
    ...mapActions('abnormal', ['getUserBillList', 'listAllCoin']),
    refreshList(data = {}) {
      this.getBill({
        ...this.pagination,
        ...data
      });
    },
    getBill(data) {
      this.getUserBillList({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.listAllCoin();
    this.getBill();
  },
  components: {
    BillList
  }
};
</script>

<style lang="less" scoped></style>
